import React, { useMemo } from 'react'
import {
  Container,
  LineContainer,
  Line,
  Property,
  Values,
  Value,
  InnerValue,
  ColorSwatch,
  Punctuation,
} from './CodeBlock.styles'
import { CSStyles, InnerPropertyStyle } from '../../useGenerateLayerCSS'

export interface CodeBlockProps {
  styles: CSStyles
  className?: string
}

export const CodeBlock = ({ styles, className }: CodeBlockProps) => {
  const renderedStyles = useMemo(() => {
    const renderValue = (
      styleValue: InnerPropertyStyle,
      lastItem: boolean = true
    ) => {
      if (styleValue.innerProperty) {
        const { property, values } = styleValue.innerProperty

        const innerValues = values.map((iv, index) => {
          return (
            <Value key={iv.value}>
              {iv.value ? <InnerValue>{iv.value}</InnerValue> : undefined}
              {iv.color ? (
                <>
                  <ColorSwatch background={iv.color} spaceLeft={!!iv.value} />
                  <InnerValue>{iv.color}</InnerValue>
                </>
              ) : undefined}
              {index < values.length - 1 ? (
                <Punctuation>,&nbsp;</Punctuation>
              ) : undefined}
            </Value>
          )
        })

        return (
          <>
            {property ? <Value>{property}(</Value> : undefined}
            {innerValues}
            {property ? <Value>)</Value> : undefined}
            <Punctuation>{lastItem ? <>;</> : <>,&nbsp;</>}</Punctuation>
          </>
        )
      }

      return (
        <Value>
          {styleValue.value ? (
            <InnerValue>{styleValue.value}</InnerValue>
          ) : undefined}
          {styleValue.color ? (
            <>
              <ColorSwatch
                background={styleValue.color}
                spaceLeft={!!styleValue.value}
              />
              <InnerValue>{styleValue.color}</InnerValue>
            </>
          ) : undefined}
          {lastItem ? (
            <Punctuation>;</Punctuation>
          ) : (
            <Punctuation>,&nbsp;</Punctuation>
          )}
        </Value>
      )
    }

    return styles.map((style, index) => {
      return (
        <LineContainer key={`line-${index}`}>
          <Line>
            <Property>{style.property}:</Property>
            <Values>
              {style.values.map((value, index) =>
                renderValue(value, index === style.values.length - 1)
              )}
            </Values>
          </Line>
        </LineContainer>
      )
    })
  }, [styles])

  return <Container className={className}>{renderedStyles}</Container>
}
